import React from 'react';
import { ShieldCheck, ArrowRight } from 'lucide-react';

const JoinButton = () => (
  <a href="/packages-academy">
    <button className="flex justify-center w-60 space-x-2 bg-gradient-to-r from-blue-600 to-purple-600 text-white p-4 rounded-3xl hover:shadow-lg transform hover:scale-105 transition-all duration-300 hover:w-full hover:justify-evenly ">
      <ShieldCheck className="w-6 h-6 animate-ping" />
      <span>Gabung Sekarang</span>
      <ArrowRight className="w-6 h-6 transition-transform duration-300 hover:rotate-0 -rotate-45" />
    </button>
  </a>
  
);

export default JoinButton;